var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDrivers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.197,
    height: 126.215,
    viewBox: "0 0 193.197 126.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3663",
    "data-name": "Gruppe 3663",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M838.16,518.823a39.91,39.91,0,0,1-1.864,11.032c-.025.083-.053.165-.08.247h-6.957c.007-.074.015-.157.022-.247.464-5.333-2.186-37.4-5.384-42.953C824.176,487.351,838.7,501.878,838.16,518.823Z",
    transform: "translate(-670.99 -414.96)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M862.4,587.489c-.058.083-.119.166-.181.247H857l.139-.247c.862-1.556,3.414-6.209,5.783-11.032,2.545-5.183,4.881-10.563,4.684-12.51C867.671,564.386,869.433,577.773,862.4,587.489Z",
    transform: "translate(-695.756 -472.594)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133-2",
    "data-name": "Path 133",
    d: "M924.715,581.866a21.881,21.881,0,0,1-1.022,6.048c-.014.046-.029.09-.044.136h-3.814c0-.041.008-.086.012-.136.254-2.923-1.2-20.5-2.952-23.548C917.049,564.613,925.011,572.577,924.715,581.866Z",
    transform: "translate(-740.558 -472.907)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134-2",
    "data-name": "Path 134",
    d: "M938.006,619.509c-.032.045-.065.091-.1.136h-2.861l.076-.136c.473-.853,1.872-3.4,3.17-6.048,1.4-2.841,2.676-5.791,2.568-6.858C940.894,606.844,941.86,614.183,938.006,619.509Z",
    transform: "translate(-754.135 -504.503)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133-3",
    "data-name": "Path 133",
    d: "M781.715,581.866a21.881,21.881,0,0,1-1.022,6.048c-.014.046-.029.09-.044.136h-3.814c0-.041.008-.086.012-.136.254-2.923-1.2-20.5-2.952-23.548C774.049,564.613,782.011,572.577,781.715,581.866Z",
    transform: "translate(-633.587 -472.907)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134-3",
    "data-name": "Path 134",
    d: "M795.006,619.509c-.032.045-.065.091-.1.136h-2.861l.076-.136c.473-.853,1.872-3.4,3.17-6.048,1.4-2.841,2.676-5.791,2.568-6.858C797.894,606.844,798.86,614.183,795.006,619.509Z",
    transform: "translate(-647.165 -504.503)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3924",
    "data-name": "Pfad 3924",
    d: "M314.572,400.1h3.667l1.745-14.146h-5.413Z",
    transform: "translate(-235.315 -288.713)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3925",
    "data-name": "Pfad 3925",
    d: "M527.871,638.712h7.223a4.6,4.6,0,0,1,4.6,4.6v.15H527.871Z",
    transform: "translate(-449.549 -528.522)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3926",
    "data-name": "Pfad 3926",
    d: "M235.761,400.1h3.667l1.745-14.146H235.76Z",
    transform: "translate(-176.36 -288.713)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3927",
    "data-name": "Pfad 3927",
    d: "M449.059,638.712h7.223a4.6,4.6,0,0,1,4.6,4.6v.15H449.059Z",
    transform: "translate(-390.594 -528.522)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3928",
    "data-name": "Pfad 3928",
    d: "M229.832,187.638v37.35l.946,24.112h7.8l2.6-45.387,5.2,18.675,3.31,26.239,9.456-.473-6.382-60.516Z",
    transform: "translate(-171.925 -140.362)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_534",
    "data-name": "Ellipse 534",
    cx: 5.673,
    cy: 5.673,
    r: 5.673,
    transform: "translate(61.302 2.362)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3929",
    "data-name": "Pfad 3929",
    d: "M247.773,60.275l-1.51,1.6-1.418,31.913,16.784-.473-4.019-27.894-3.546-3.4-1.8-1.743Z",
    transform: "translate(-183.155 -45.089)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3930",
    "data-name": "Pfad 3930",
    d: "M443.139,269.338l1.274-2.068.381,4.432s3.073,9.928,2.837,18.675,1.182,29.312-.709,29.549-9.928.709-9.928-.946-.473-45.623-.473-45.623Z",
    transform: "translate(-381.214 -250.665)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3931",
    "data-name": "Pfad 3931",
    d: "M496.572,267.27l3.217,2.54,7.092,2.6s0,30.258,1.418,37.35,4.019,7.8.709,8.037-3.073-.946-3.073-.946,2.364-11.819-.709-14.183-8.983-16.074-8.51-23.639S496.1,267.27,496.572,267.27Z",
    transform: "translate(-426.044 -250.665)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3932",
    "data-name": "Pfad 3932",
    d: "M457.2,211.176s.482-.847.37-3.674,4.194-1.229,7.792-1.5,2.837,4.721,2.837,4.721a9.409,9.409,0,0,0,.815-2.706,7.864,7.864,0,0,0-.706-4.809c-.372-2.531-2.375-1.72-2.375-1.72a1.05,1.05,0,0,1,.779,1.178c-.817-1.432-2.82-.62-2.82-.62-2.671-1.676-5.379.531-5.379.531-3.227.732-1.335,3.3-1.335,3.3C453.939,207.518,457.2,211.176,457.2,211.176Z",
    transform: "translate(-395.597 -201.366)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3933",
    "data-name": "Pfad 3933",
    d: "M426.064,427.959a2.393,2.393,0,0,0-.424-3.645l1.022-5.373-3.113-1.417-1.337,7.607a2.406,2.406,0,0,0,3.852,2.828Z",
    transform: "translate(-370.277 -363.062)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3934",
    "data-name": "Pfad 3934",
    d: "M426.041,290.428l-.628-.337s-3.391,1.282-3.155,2.228-1.891,34.04-1.182,35.222,6.383.236,6.383.236Z",
    transform: "translate(-369.553 -267.737)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3935",
    "data-name": "Pfad 3935",
    d: "M542.858,418.379a2.393,2.393,0,0,1-.084-3.669l-1.755-5.179,2.887-1.835,2.376,7.349a2.406,2.406,0,0,1-3.424,3.333Z",
    transform: "translate(-459.384 -355.711)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3936",
    "data-name": "Pfad 3936",
    d: "M526.148,320.519s5.75.151,6.288-1.117-6.147-33.75-6.044-34.72-3.432-1.77-3.432-1.77l-.575.42Z",
    transform: "translate(-445.445 -262.367)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3937",
    "data-name": "Pfad 3937",
    d: "M612.684,347.938l-3.56-17.442-1.564-12.883-3.464,2.241.479,14.2L610.1,348.76a1.927,1.927,0,1,0,2.58-.822Z",
    transform: "translate(-506.569 -288.324)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3938",
    "data-name": "Pfad 3938",
    d: "M503.625,352.037l.985-17.775-.326-12.973,4.58,1.713.765,14.116L506.3,352.475a1.927,1.927,0,1,1-2.672-.438Z",
    transform: "translate(-430.803 -291.074)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3939",
    "data-name": "Pfad 3939",
    d: "M327.1,420.27h2.34l1.113-9.026H327.1Z",
    transform: "translate(-244.686 -307.63)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3940",
    "data-name": "Pfad 3940",
    d: "M541.742,645.4h4.609a2.937,2.937,0,0,1,2.937,2.937v.1h-7.546Z",
    transform: "translate(-459.925 -533.526)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3941",
    "data-name": "Pfad 3941",
    d: "M362.281,416.476l2.313.358,2.48-8.75-3.413-.528Z",
    transform: "translate(-271.004 -304.872)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3942",
    "data-name": "Pfad 3942",
    d: "M576.037,640.966l4.554.7h0a2.937,2.937,0,0,1,2.453,3.351l-.015.094-7.457-1.153Z",
    transform: "translate(-485.232 -530.208)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3943",
    "data-name": "Pfad 3943",
    d: "M515.356,438.98l-.012-.065-8.472-45.8a17.3,17.3,0,0,1,1.529-10.82l5.128-10.255,15.3,2.073,1.806,13.056,6.435,24.907-.006.02-8.244,26.188-5.4.355,4.786-23.377-8.764-19.905.618,43.27Z",
    transform: "translate(-433.629 -329.035)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3944",
    "data-name": "Pfad 3944",
    d: "M540.431,315.483l-.1-.158c-.018-.029-1.877-2.829-6.934-.959-5.163,1.909-9.163-1.778-9.2-1.815l-.02-.019L523,302.111l-1.38-8.46,4.394-.771,2.16-1.3,8.59-.153,2.26,1.778,3.711.4.34,7.709,0,.008Z",
    transform: "translate(-444.875 -268.739)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3945",
    "data-name": "Pfad 3945",
    d: "M601.156,308.391v-6.6l1.044-1.9h.042a3.129,3.129,0,0,1,2.161.982c1.05,1.067,1.525,2.843,1.413,5.281l0,.045Z",
    transform: "translate(-504.37 -275.063)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3946",
    "data-name": "Pfad 3946",
    d: "M513.044,307.821l-5.319-.638,0-.061c-.181-2.652.281-4.621,1.376-5.852a3.374,3.374,0,0,1,2.18-1.187h.031l1.44,1.309Z",
    transform: "translate(-434.447 -275.209)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3947",
    "data-name": "Pfad 3947",
    d: "M545.294,238.6h-14a1.087,1.087,0,0,1-1.086-1.086v-5.068a8.084,8.084,0,1,1,16.168,0v5.068A1.087,1.087,0,0,1,545.294,238.6Z",
    transform: "translate(-451.3 -218.57)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_535",
    "data-name": "Ellipse 535",
    cx: 5.927,
    cy: 5.927,
    r: 5.927,
    transform: "translate(81.394 8.129)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3948",
    "data-name": "Pfad 3948",
    d: "M550.13,236.212h-7.825a.6.6,0,0,1-.6-.529l-.1-.81a.362.362,0,0,0-.687-.108l-.513,1.1a.605.605,0,0,1-.547.348H538.67a.6.6,0,0,1-.6-.661l.469-4.9a.608.608,0,0,1,.345-.491,12.237,12.237,0,0,1,10.8.006.6.6,0,0,1,.341.463l.7,4.889a.6.6,0,0,1-.6.689Z",
    transform: "translate(-457.175 -221.971)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3949",
    "data-name": "Pfad 3949",
    d: "M590.069,412.148a2.165,2.165,0,0,0,1.16-3.11l5.073-5.783-3.96-.546-4.21,5.576a2.176,2.176,0,0,0,1.938,3.864Z",
    transform: "translate(-493.894 -351.98)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3950",
    "data-name": "Pfad 3950",
    d: "M390.5,401.714h-3.538l-1.683-13.647H390.5Z",
    transform: "translate(-288.205 -290.293)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3951",
    "data-name": "Pfad 3951",
    d: "M592.719,643.6H581.31v-.144a4.441,4.441,0,0,1,4.44-4.44h6.969Z",
    transform: "translate(-489.524 -528.747)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3952",
    "data-name": "Pfad 3952",
    d: "M452.69,391.785l-3.379,1.049L443.656,380.3l4.987-1.548Z",
    transform: "translate(-331.876 -283.325)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3953",
    "data-name": "Pfad 3953",
    d: "M670.9,630.785l-10.9,3.383-.043-.138a4.441,4.441,0,0,1,2.924-5.558h0l6.655-2.066Z",
    transform: "translate(-548.213 -519.317)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M596.7,393.871l-5.24,6,4.1.369Z",
    transform: "translate(-497.115 -345.369)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M597.941,422.774s-1.82.91-2.048,5.005.683,14.789.683,14.789a26.71,26.71,0,0,0,0,9.1c.91,4.323-.91,20.021.228,20.021s7.053.683,7.281,0,.455-10.921.455-10.921,1.82-5.233,0-8.417c0,0,6.355,11.1,10.466,19.566.9,1.854,7.735-.228,6.6-2.275s-3.868-11.376-3.868-11.376-2.048-6.826-5.688-9.783l1.82-14.561s3.868-9.783,1.593-11.148S597.941,422.774,597.941,422.774Z",
    transform: "translate(-500.405 -366.536)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 5.915,
    cy: 5.915,
    r: 5.915,
    transform: "translate(98.445 7.321)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M613.276,279.187l-7.354,4.323a9.669,9.669,0,0,0-3.868,4.323,13.147,13.147,0,0,0,0,7.963c.91,1.82-.382,6.37-.382,6.37l-1.138,10.466s-4.1,3.868-.91,4.323,8.873-.228,12.286,0,7.28.683,6.143-1.593-2.5-3.868-1.138-8.417c1.068-3.561,1.022-16.874.951-22.5a4.526,4.526,0,0,0-2.2-3.825Z",
    transform: "translate(-502.317 -259.58)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M623.374,307.633l.682,13.878-6.615,13.4-1.122-.427,6.826-12.513Z",
    transform: "translate(-515.713 -280.859)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M651.148,369.725v-1.593l-7.735,12.741Z",
    transform: "translate(-535.98 -326.115)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M608.93,221.839l-.977-.391a6.672,6.672,0,0,1,4.889-2.055l-.8-.881a3.4,3.4,0,0,1,3.734,1.272,17.382,17.382,0,0,1,2.691,3.781h1.047l-.437.963,1.53.962-1.57-.172a5.327,5.327,0,0,1-.148,2.493l.043.761a23.44,23.44,0,0,1-1.821-3.209v.979s-.978-.881-.978-1.468l-.534.685-.267-1.076-3.289,1.076.533-.881-2.045.294.8-1.076s-2.311,1.272-2.4,2.349a5.773,5.773,0,0,1-1.245,2.447l-.533-.979S606.353,223.308,608.93,221.839Z",
    transform: "translate(-508.768 -214.082)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3954",
    "data-name": "Pfad 3954",
    d: "M620.044,413.46a2.165,2.165,0,0,0,.589-3.267L624.6,403.6l-3.994.165L617.452,410a2.176,2.176,0,0,0,2.593,3.459Z",
    transform: "translate(-516.054 -352.648)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M631,289.915l1.706-.341s5.119,3.754,3.526,11.262-8.646,18.884-8.646,18.884-1.593,2.048-2.048,2.5-1.365,0-.91.683-.683,1.138-.683,1.138-5.005,0-4.55-1.82,8.191-14.789,8.191-14.789l-1.138-12.058S625.536,289.46,631,289.915Z",
    transform: "translate(-517.99 -267.35)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3955",
    "data-name": "Pfad 3955",
    d: "M525.006,657.87H371.064a.252.252,0,0,1,0-.5H525.006a.252.252,0,0,1,0,.5Z",
    transform: "translate(-332.061 -542.476)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3956",
    "data-name": "Pfad 3956",
    d: "M1.084,0H.4C.178,0,0,.248,0,.555v2.03c0,.306.178.555.4.555H4.165c.22,0,.4-.248.4-.555V.555c0-.306-.178-.555-.4-.555H1.084Z",
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 4.058, 14.762)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3957",
    "data-name": "Pfad 3957",
    d: "M307.643,264.959c.055,7.428-4.691,6.3-10.477,6.3s-9.972,1.106-10.477-6.3c-.8-11.776,2.291-20.594,10.477-20.594C305.633,244.365,307.555,253.184,307.643,264.959Z",
    transform: "translate(-269.041 -233.531)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3958",
    "data-name": "Pfad 3958",
    d: "M224.835,258.724a2.886,2.886,0,0,1-1.783,4.051l-.528,10.244-4.293-3.16,1.159-9.243a2.9,2.9,0,0,1,5.444-1.892Z",
    transform: "translate(-217.923 -243.051)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3959",
    "data-name": "Pfad 3959",
    d: "M382.251,450.376a2.886,2.886,0,0,0-1.261-4.243l.761-10.229-4.655,2.6-.009,9.316a2.9,2.9,0,0,0,5.164,2.56Z",
    transform: "translate(-336.629 -376.812)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3960",
    "data-name": "Pfad 3960",
    d: "M95.983,447.109H99.5l1.674-13.573H95.982Z",
    transform: "translate(-71.799 -324.305)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3961",
    "data-name": "Pfad 3961",
    d: "M309.432,684.213h6.93a4.416,4.416,0,0,1,4.417,4.417v.143H309.432Z",
    transform: "translate(-286.146 -562.559)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3962",
    "data-name": "Pfad 3962",
    d: "M184.844,447.109h3.519l1.674-13.573h-5.194Z",
    transform: "translate(-138.272 -324.305)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3963",
    "data-name": "Pfad 3963",
    d: "M398.293,684.213h6.93a4.416,4.416,0,0,1,4.416,4.417v.143H398.293Z",
    transform: "translate(-352.618 -562.559)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3964",
    "data-name": "Pfad 3964",
    d: "M371.612,367.119l-.153-.028c-1.282-.232-2.579-.467-3.72-.712l-.113-.024v-.115c-.02-5.2-.039-10.4-.068-15.654a33.087,33.087,0,0,1-3.308-17.736l.006-.064.053-.038a3.4,3.4,0,0,1,3.429-.265,3.8,3.8,0,0,1,1.952,2.886c1.037,5.653,2.111,11.508,3.309,17.276l0,.021,0,.022c-.444,4.7-.9,9.57-1.373,14.277Z",
    transform: "translate(-327.048 -299.191)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3965",
    "data-name": "Pfad 3965",
    d: "M311.45,472.269l-.028-.132c-1.646-7.787-3.235-14.128-4.772-20.26-1.842-7.349-3.587-14.313-5.349-23.325.242,11.365.8,19.529,1.45,28.914.292,4.238.593,8.62.9,13.735l.009.156-.156,0c-5.508-.141-11.15-.481-16.607-.81l-.144-.009.01-.144c1.033-15.228,1.357-25.124,1.593-32.349.5-15.244.575-17.587,6.254-30.488.215-.489,1.5-1.936,2.911-1.715l11.172,1.739.02.1c.315,1.588,1.88,6.406,4.045,13.076,4.629,14.257,11.624,35.8,13.809,48.645l.025.145-.146.021c-3.174.451-5.458.921-7.667,1.375-2.09.43-4.251.874-7.193,1.313Z",
    transform: "translate(-269.18 -354.303)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3966",
    "data-name": "Pfad 3966",
    d: "M301.81,346.955a11.658,11.658,0,0,1-8.042-3.049,2.385,2.385,0,0,1-1.176-1.853,2.418,2.418,0,0,1,.568-1.962c-2.072-2.507-4.21-5.1-6.258-7.738l-.057-.073.065-.125c1.339-2.559,2.725-5.205,4.055-7.82a1.366,1.366,0,0,1,1.114-.844,1.589,1.589,0,0,1,1.227.274l0-.064c.056-1.324.111-2.647.168-3.9l.006-.134.134,0c2.558-.056,5.2-.115,7.8-.269l.1-.006,1.288,2.874a10.537,10.537,0,0,1,6.046,1.227l.085.045-.01.1a58.516,58.516,0,0,0,.335,14.835,30.326,30.326,0,0,1-.538,6.361l-.013.053-.046.031A12.257,12.257,0,0,1,301.81,346.955Z",
    transform: "translate(-269.25 -289.652)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3967",
    "data-name": "Pfad 3967",
    d: "M238.594,313.24l-.172-.079c-2-1.005-4.013-2.12-5.957-3.2l-.269-.052c-5.118-1.027-7.937-1.593-12.554-4.3l-.035-.021-.019-.036c-2.312-4.416-2.957-8.277-2.379-14.243l.012-.12.12-.01c.5-.041,1.316-.068,2.105-.094.767-.026,1.561-.052,2.048-.09l.113-.009.035.108c.6,1.868,1.119,3.611,1.663,5.456.559,1.9,1.137,3.857,1.841,6.036,2.578.741,9.489.519,11.638.227a3.845,3.845,0,0,1,3.357,1.527l.04.05-.01.063c-.473,2.887-1.016,5.791-1.542,8.6Z",
    transform: "translate(-217.01 -268.406)",
    fill: "#b9f6ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_536",
    "data-name": "Ellipse 536",
    cx: 7.05,
    cy: 7.05,
    r: 7.05,
    transform: "translate(18.428 24.679) rotate(-61.337)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3968",
    "data-name": "Pfad 3968",
    d: "M296.166,264.36h2.788l1.23-3.444.246,3.444h1.333l.718-2.009.144,2.009h9.9a7.463,7.463,0,0,0-7.463-7.463h-1.435a7.463,7.463,0,0,0-7.463,7.463Z",
    transform: "translate(-276.222 -242.906)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_537",
    "data-name": "Ellipse 537",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(6.197 13.107)",
    fill: "#e0e0e0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDrivers);
export default __webpack_public_path__ + "static/media/NoDrivers.8581bb04d7581973ac68bf50720ec304.svg";
export { ForwardRef as ReactComponent };